(() => {
  const V = window.VIVCER;
  if (!V) return;

  const { scroll, prefersReducedMotion } = V;
  const { directions, velocity, progress, thresholds } = scroll;

  const getRowHeight = () => {
    const raw = getComputedStyle(document.documentElement)
      .getPropertyValue("--vivcer-row-height")
      .trim();
    const px = parseFloat(raw) * (raw.endsWith("rem") ? parseFloat(getComputedStyle(document.documentElement).fontSize) : 1);
    return Number.isFinite(px) && px > 0 ? px : 28;
  };

  const resolveVelocity = (v) => {
    const abs = Math.abs(v);
    if (abs < 0.01)                       return velocity.still;
    if (abs < thresholds.velocitySlow)    return velocity.slow;
    if (abs < thresholds.velocityFast)    return velocity.medium;
    return velocity.fast;
  };

  const resolveProgress = (scrollY, limit, rowH) => {
    if (scrollY <= rowH)              return progress.top;
    if (scrollY >= limit - rowH)      return progress.bottom;
    return progress.middle;
  };

  const initLenis = () => {
    const Lenis = window.Lenis;
    if (!Lenis) return;

    if (prefersReducedMotion()) {
      document.documentElement.setAttribute("data-scroll-dir", directions.idle);
      document.documentElement.setAttribute("data-scroll-velocity", velocity.still);
      document.documentElement.setAttribute("data-scroll-progress", progress.top);
      return;
    }

    const lenis = new Lenis({
      smoothWheel: true,
      syncTouch:   true,
      lerp:        0.1,
      duration:    1.2,
      easing:      (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
    });

    let lastDir  = directions.idle;
    let lastVel  = velocity.still;
    let lastProg = progress.top;

    lenis.on("scroll", ({ scroll: scrollY, limit, velocity: vel, direction }) => {
      const rowH    = getRowHeight();
      const nextDir = direction > 0 ? directions.down : direction < 0 ? directions.up : directions.idle;
      const nextVel = resolveVelocity(vel);
      const nextProg = resolveProgress(scrollY, limit, rowH);

      if (nextDir !== lastDir) {
        document.documentElement.setAttribute("data-scroll-dir", nextDir);
        lastDir = nextDir;
      }
      if (nextVel !== lastVel) {
        document.documentElement.setAttribute("data-scroll-velocity", nextVel);
        lastVel = nextVel;
      }
      if (nextProg !== lastProg) {
        document.documentElement.setAttribute("data-scroll-progress", nextProg);
        lastProg = nextProg;
      }
    });

    document.documentElement.setAttribute("data-scroll-dir",      directions.idle);
    document.documentElement.setAttribute("data-scroll-velocity",  velocity.still);
    document.documentElement.setAttribute("data-scroll-progress",  progress.top);

    const tick = (t) => (lenis.raf(t), requestAnimationFrame(tick));
    requestAnimationFrame(tick);

    window.VIVCER_LENIS = lenis;
  };

  document.addEventListener("DOMContentLoaded", initLenis);
})();
